import styled, { css } from 'styled-components';

interface DesktopSidebarWrapperProps {
  fixed?: boolean;
}

export const DesktopSidebarWrapper = styled('nav')<DesktopSidebarWrapperProps>`
  width: ${({ theme }) => theme.sidebarWidth}px;
  ${({ fixed }) =>
    fixed &&
    css`
      margin-left: -${({ theme }) => theme.sidebarWidth}px;
      position: fixed;
    `}
  margin-top: ${({ theme }) => theme.x4spacePx}px;
  padding-left: ${({ theme }) => theme.x3spacePx}px;
`;

interface ListItemProps {
  listType?: string;
}

export const List = styled('ul')<ListItemProps>`
  padding-left: ${({ theme, listType }) =>
    listType === 'ol' ? theme.x2spacePx : 0}px;
  ${({ listType }) =>
    listType === 'ol' &&
    css`
      list-style-type: decimal;
    `};
  > li {
    padding-left: ${({ theme, listType }) =>
      listType === 'ol' ? theme.x1spacePx : 0}px;
    &:before {
      left: -${({ theme, listType }) => (listType === 'ol' ? theme.x5space * 10 : theme.x3spacePx)}px;
    }
  }
`;

interface ListItemProps {
  selected?: boolean;
}

export const ListItem = styled('li')<ListItemProps>`
  color: ${({ theme }) => theme.color.whiteRGBA(0.5)};
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;

  position: relative;
  ${({ selected }) =>
    selected &&
    css`
      color: white;
      font-weight: 700;
      &:before {
        content: '';
        display: block;
        position: absolute;
        width: ${({ theme }) => theme.x1spacePx / 2}px;
        height: 100%;
        top: 0;
        background: ${({ theme }) => theme.color.brand01};
      }
    `};
  &:last-child {
    margin-bottom: 0;
  }

  > a {
    box-shadow: none;
    color: inherit;
    &:hover {
      box-shadow: none;
    }
  }
`;
